import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common components
import {
  FullScreenLoading,
  Form,
  TextInput,
  Button,
  StaticDropdown,
} from "src/Components";
import UsersDropdown from "src/Components/Dropdown/Users/UsersDropdown";
// requests
import {
  addFundNoRisk,
  editFundNoRisk,
  getBuyingPowerCriteria,
  getSandooghsDropDown,
} from "src/Requests/fundNoRiskTask";
// types
import {
  IFundNoRiskAddTaskDTO,
  IBuyingPowerCriterionDropdownDTO,
  ISandooghDropdownDTO,
} from "src/Interfaces/fundNoRisk";
// Hooks
import { useAppDispatch, useAppSelector } from "src/App/hooks";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { addComma, removeComma } from "src/helper";
// Reducers
import { setAddEditFundNotRiskFormValues } from "src/Features/FundNoRisk/fundNoRiskSlice";

interface Props {
  onSuccess: () => void;
  onClose: () => void;
}
const AddTask: React.FC<Props> = (props) => {
  // hooks
  const dispatch = useAppDispatch();

  const formValues = useAppSelector(
    (store) => store.fundNoRisk.addEditFormValues ?? {}
  );

  // local states
  const [loading, setLoading] = React.useState<boolean>(false);

  const [fundInstruments, setfundInstruments] = React.useState<
    ISandooghDropdownDTO[]
  >([]);
  const [buyingPowerCriteria, setBuyingPowerCriteria] = React.useState<
    IBuyingPowerCriterionDropdownDTO[]
  >([]);

  React.useEffect(() => {
    Promise.all([getSandooghsDropDown(), getBuyingPowerCriteria()])
      .then(([instruments, criteria]) => {
        setfundInstruments(instruments);
        setBuyingPowerCriteria(criteria);

        if (formValues.buyingPowerCriterion == null) {
          dispatch(
            setAddEditFundNotRiskFormValues({
              ...formValues,
              buyingPowerCriterion: 0,
            })
          );
        }
      })
      .catch(packetErrorHandler);
    // Initial form values are intentionally captured once when the modal opens.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const changeHandler = (name: string, value: any) => {
    dispatch(
      setAddEditFundNotRiskFormValues({
        ...formValues,
        [name]: value,
      })
    );
  };

  const changePriceHandler = (name: string, value: string) => {
    const normalizedValue = removeComma(value);
    if (!/^-?\d*$/.test(normalizedValue)) return;

    dispatch(
      setAddEditFundNotRiskFormValues({
        ...formValues,
        [name]: normalizedValue,
      })
    );
  };
  const getProperFunction = () => {
    const data = {
      ...formValues,
      minBuyPower: Number(formValues.minBuyPower ?? 0),
      buyPowerTarget: Number(formValues.buyPowerTarget ?? 0),
    };

    if (data.id) return editFundNoRisk(data);
    return addFundNoRisk(data);
  };

  const clickHandler = () => {
    setLoading(true);
    getProperFunction()
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          props.onSuccess();
          props.onClose();
          dispatch(
            setAddEditFundNotRiskFormValues({} as IFundNoRiskAddTaskDTO)
          );
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {loading ? <FullScreenLoading /> : <></>}
      <div className="text-[10px] whitespace-nowrap w-auto">نام اکانت</div>
      <UsersDropdown
        label="نام اکانت"
        name="accountId"
        value={formValues.accountId}
        onChange={changeHandler}
      />
      <StaticDropdown
        dropdown={{
          name: "buyingPowerCriterion",
          placeholder: "معیار انتخابی",
          extraLabel: true,
        }}
        onChange={(name, value) => changeHandler(name, Number(value))}
        options={buyingPowerCriteria}
        value={(formValues.buyingPowerCriterion ?? 0).toString()}
      />
      <TextInput
        label="حداقل معیار"
        name="minBuyPower"
        value={addComma(formValues.minBuyPower ?? 0)}
        onChange={changePriceHandler}
        extraLabel
      />
      <TextInput
        label="معیار هدف"
        name="buyPowerTarget"
        value={addComma(formValues.buyPowerTarget ?? 0)}
        onChange={changePriceHandler}
        extraLabel
      />
      <StaticDropdown
        dropdown={{
          name: "firstSellPriority",
          placeholder: "اولویت اول فروش",
          extraLabel: true,
        }}
        onChange={changeHandler}
        options={fundInstruments}
        value={formValues.firstSellPriority?.toString()}
      />
      <StaticDropdown
        dropdown={{
          name: "secondSellPriority",
          placeholder: "اولویت دوم فروش",
          extraLabel: true,
        }}
        onChange={changeHandler}
        options={fundInstruments}
        value={formValues.secondSellPriority?.toString()}
      />
      <StaticDropdown
        dropdown={{
          name: "buyInstrumentTarget",
          placeholder: "نماد هدف خرید",
          extraLabel: true,
        }}
        onChange={changeHandler}
        options={fundInstruments}
        value={formValues.buyInstrumentTarget?.toString()}
      />

      <Button
        text="ثبت"
        onClick={clickHandler}
        variant="contained"
        disabled={false}
      />
    </Form>
  );
};

export default AddTask;
